import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 h-[350px] md:h-[500px] relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%2C%20romantic%20couple%20scene%2C%20warm%20pastel%20color%20palette%2C%20soft%20lighting%2C%20dreamy%20atmosphere%2C%20cherry%20blossom%20background%2C%20digital%20illustration%2C%20emotional%20storytelling%20mood&width=1200&height=800&seq=cta-left-01&orientation=landscape"
          alt="韩漫阅读体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute top-6 left-6">
          <p className="text-white/70 text-xs font-medium tracking-wider uppercase">随时随地</p>
        </div>
        <div className="absolute bottom-6 left-6">
          <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
            沉浸式<br />阅读体验
          </h3>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 py-14 md:py-16">
        <div className="max-w-md text-center">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            现在就开始<br />你的韩漫之旅
          </h3>
          <p className="text-foreground-500 text-sm leading-relaxed mb-8">
            数千部精选韩国漫画等你来探索。无论是甜蜜恋爱还是热血冒险，这里总有一部作品能触动你的心弦。免费阅读，高清画质，流畅下拉式体验。
          </p>
          <Link
            to="/category/romance"
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}